import { SaveAlert } from './SaveAlert';
import { SaveAlertConfiguration } from './SaveAlertConfiguration';

export type Mutations = {
  SaveAlert: typeof SaveAlert;
  SaveAlertConfiguration: typeof SaveAlertConfiguration;
};

export const mutations: Mutations = {
  SaveAlert,
  SaveAlertConfiguration,
};
